// Espelha App\Constants\SubRoleCriteriaTypes do backend-core.
export const CRITERIA_ALL = "all";
export const CRITERIA_ANY = "any";
export const CRITERIA_REVENUE_MIN = "revenue_min";
export const CRITERIA_CERTIFICATE_APPROVED = "certificate_approved";
export const CRITERIA_ROLE_IN = "role_in";
export const CRITERIA_PHYSICAL_FRANCHISE_LEADER = "physical_franchise_leader";

/**
 * Traduz um item de critério vindo da API para algo exibível.
 * Um tipo desconhecido nunca é dado como concluído: ele ainda depende de
 * validação do Plano de Carreira.
 */
export function describeCriteriaItem(item) {
  if (!item) return null;

  const base = {
    type: item.type,
    satisfied: Boolean(item.satisfied),
    current: null,
    target: null,
    options: null,
    // Como o requisito aparece dentro de uma frase: "Falta <gapLabel> para alcançar Hunter 1".
    // Critério numérico não tem: ali a frase cita o valor que falta, não o nome do requisito.
    gapLabel: null,
  };

  switch (item.type) {
    case CRITERIA_REVENUE_MIN:
      return {
        ...base,
        label: "Faturamento acumulado",
        current: item.current,
        target: item.target,
      };

    case CRITERIA_CERTIFICATE_APPROVED:
      return {
        ...base,
        label: `Certificação: ${item.certificate_type_name || "a definir"}`,
        gapLabel: item.certificate_type_name
          ? `a certificação ${item.certificate_type_name}`
          : "uma certificação ainda a definir",
      };

    case CRITERIA_ROLE_IN:
      return {
        ...base,
        label: `Nível de comissionamento: ${(item.role_names || []).join(" ou ")}`,
        gapLabel: `o nível de comissionamento ${(item.role_names || []).join(" ou ")}`,
      };

    case CRITERIA_PHYSICAL_FRANCHISE_LEADER:
      return {
        ...base,
        label: "Responder por uma Unidade Física",
        gapLabel: "responder por uma Unidade Física",
      };

    // A matriz tem exigências alternativas ("R$50.000,00 ou Certificado Hunter e Closer").
    // Elas chegam agrupadas para que a tela não as cobre como se fossem obrigatórias.
    case CRITERIA_ANY:
      return {
        ...base,
        label: "Basta cumprir uma destas alternativas",
        options: (item.options || [])
          .map((option) => ({
            satisfied: Boolean(option.satisfied),
            items: (option.items || [])
              .map(describeCriteriaItem)
              .filter((subItem) => subItem !== null),
          }))
          .filter((option) => option.items.length > 0),
      };

    default:
      return {
        ...base,
        satisfied: false,
        label: "Critério em validação pela Futuro",
        gapLabel: "um critério ainda em validação pela Futuro",
      };
  }
}
